export const LOADING_TAB_HTML = `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>Generating PDF…</title>
    <style>
      html, body { height: 100%; margin: 0; }
      body {
        display: flex; align-items: center; justify-content: center;
        background: #fff; color: #4b5563;
        font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      }
      .wrap { display: flex; flex-direction: column; align-items: center; gap: 16px; }
      .spinner {
        width: 40px; height: 40px; border: 4px solid #e5e7eb;
        border-top-color: #4b5563; border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }
      @keyframes spin { to { transform: rotate(360deg); } }
    </style>
  </head>
  <body>
    <div class="wrap">
      <div class="spinner"></div>
      <div>Generating PDF…</div>
    </div>
  </body>
</html>`;
